var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBigGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 27.0459C4 36.784 10.4462 45.0466 19.3886 47.962C20.5136 48.1645 20.9242 47.4839 20.9242 46.8997C20.9242 46.3761 20.9045 44.9901 20.8933 43.1507C14.6341 44.4831 13.3136 40.1954 13.3136 40.1954C12.2913 37.6493 10.8161 36.9714 10.8161 36.9714C8.77281 35.6033 10.9708 35.6308 10.9708 35.6308C13.2278 35.7865 14.4161 37.9028 14.4161 37.9028C16.4242 41.2714 19.6825 40.2987 20.965 39.7338C21.1689 38.3092 21.7511 37.3379 22.3937 36.7868C17.3973 36.2302 12.145 34.3398 12.145 25.8927C12.145 23.4857 13.0211 21.5182 14.4611 19.9765C14.2291 19.4185 13.457 17.1782 14.6805 14.143C14.6805 14.143 16.5705 13.5505 20.868 16.4025C22.6638 15.9134 24.5875 15.6695 26.5014 15.6599C28.4125 15.6695 30.3377 15.9134 32.1348 16.4025C36.4295 13.5505 38.3153 14.143 38.3153 14.143C39.543 17.1782 38.7709 19.4185 38.5389 19.9765C39.9817 21.5182 40.8522 23.4857 40.8522 25.8927C40.8522 34.3605 35.5914 36.2246 30.5795 36.7702C31.3867 37.4509 32.1067 38.7956 32.1067 40.8526C32.1067 43.7997 32.0786 46.1763 32.0786 46.8997C32.0786 47.4894 32.4836 48.1755 33.6255 47.9592C42.5594 45.0383 49 36.7813 49 27.0459C49 14.869 38.9256 5 26.4986 5C14.0744 5 4 14.869 4 27.0459Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBigGithub);
export default __webpack_public_path__ + "static/media/ic_big_github.4d0bd4b37853a579b0e154ffc4d1b5f5.svg";
export { ForwardRef as ReactComponent };